module.exports = __webpack_public_path__ + "static/media/marker-retoure-empty.cc68c967.png";